module.exports = __webpack_public_path__ + "static/media/fm.3f19d612.svg";